import * as Yup from 'yup';

const schema = () =>
  Yup.object().shape({
    name: Yup.string().required('Name is required'),
    companyName: Yup.string().required('Company is required'),
    jobTitle: Yup.string().required('Title is required'),
    email: Yup.string().required('Email is required'),
    possibleNumberOfUsers: Yup.object().shape({
      label: Yup.string(),
      value: Yup.string().required('Number of Users is required'),
    }),
  });

export default schema;
